module.exports = __webpack_public_path__ + "img/es.558f5942.png";